import React, {FC} from 'react';
import styled from 'styled-components';

import {Dropdown} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {Anchor} from '../../../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {CommentUnfurlTypesEnum, TopicCommentUnfurlModel} from '../../../../../models/api/commentUnfurlModel';
import {TopicModel} from '../../../../../models/api/topicModel';
import {AnnotationTopicReferencePreviewerUnfurlContainer} from '../comment/unfurl/referencePreviewer/topicReferencePreviewerUnfurlContainer';

/*
 * Props.
 */

interface HoverTopicReferencePreviewerUnfurlProps {
  shouldShowPreview: boolean;
  anchor: Anchor;
  topic: TopicModel;
}

/*
 * Style.
 */

const StyledDropdown = styled(Dropdown)`
  border-radius: 12px;
  padding-top: 10px;
`;

const StyledAnnotationTopicViewerReferencePreviewerUnfurlContainer = styled(
  AnnotationTopicReferencePreviewerUnfurlContainer,
)`
  margin: 0;
`;

/*
 * Component.
 */

export const HoverTopicReferencePreviewerUnfurl: FC<HoverTopicReferencePreviewerUnfurlProps> = (props) => {
  const {topic, shouldShowPreview, anchor} = props;

  if (!shouldShowPreview) {
    return null;
  }

  const unfurl: TopicCommentUnfurlModel = {
    type: CommentUnfurlTypesEnum.TOPIC,
    token: topic.alias ?? '',
    topic,
    topicId: topic.id,
  };

  return (
    <StyledDropdown width={368} maxHeight={430} anchor={anchor} isExclusive={false} isInline>
      <StyledAnnotationTopicViewerReferencePreviewerUnfurlContainer
        key={unfurl.token}
        unfurl={unfurl}
        isRenderingUrl={false}
        isRenderingComment={false}
      />
    </StyledDropdown>
  );
};
